import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export const routes = [
  {
    path: '',
    redirect: '/storesell'
  },
  // {
  //   path: '/workbench',
  //   name: 'featureList',
  //   component: () => import('@/views/featureList.vue'),
  //   meta: { title: '功能列表' }
  // },
  // {
  //   path: '/brandrely',
  //   name: 'brandRely',
  //   component: () => import('@/views/brandRely'),
  //   meta: { title: '品牌关联' }
  // },
  {
    path: '/storesell',
    name: 'storeSell',
    permissions: [],
    component: () => import('@/views/storeSell'),
    meta: { title: '数据统计' }
  },
  {
    path: '/storedetail',
    name: 'StoreSellDetail',
    permissions: [],
    component: () => import('@/views/storeSell/storeSellDetail.vue'),
    meta: { title: '门店详情' }
  },
  {
    path: '/orderdetail',
    name: 'OrderDetail',
    permissions: [],
    component: () => import('@/views/storeSell/orderDetail.vue'),
    meta: { title: '订单详情' }
  },
  {
    path: '/unauthorize',
    name: 'unauthorize',
    component: () => import('@/views/unauthorize.vue'),
    meta: { title: '暂无权限' }
  },
  {
    path: '/checkdevice',
    name: 'checkdevice',
    component: () => import('@/views/checkDevice/checkDevice.vue'),
    meta: { title: '' }
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: () => import('@/views/order/index.vue'),
    meta: { title: '订单列表' }
  },
  {
    path: '/orderInfo',
    name: 'orderInfo',
    component: () => import('@/views/order/orderInfo.vue'),
    meta: { title: '订单详情' }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
    meta: { title: '工作台 ' }
  },
  {
    path: '/chefHome',
    name: 'chefHome',
    component: () => import('@/views/chefHome/index.vue'),
    meta: { title: '工作台 ' }
  }
]
const router = new Router({
  mode: 'history',
  routes: routes
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
    if (to.path === '/storedetail') {
      document.title = to.query.shop_name || to.meta.title
    }
  }
  next()
})

export default router
